import { RoleEnum } from '../enums/role.enum';

export class IncludeRolesRequest {
  constructor(public userId: string, public roles: Array<RoleEnum>) {}
}
